import {
  DisablePaypalIntegrationRequestParams,
  DisablePaypalIntegrationResponse,
  FetchPaypalOnboardingLinkRequestParams,
  FetchPaypalOnboardingLinkResponse,
  FetchShorePayOnlineOnboardingLinkRequestParams,
  FetchShorePayOnlineOnboardingLinkResponse,
  ToggleSubPaymentMethodV2RequestParams,
  ToggleSubPaymentMethodV2Response,
  UpdatePaymentMethodsV2Payload,
} from '../types';

export async function fetchPaypalOnboardingLink({
  apiClient,
  merchantId,
}: FetchPaypalOnboardingLinkRequestParams): Promise<FetchPaypalOnboardingLinkResponse> {
  const payload = { merchant: { id: merchantId } };
  return apiClient.payPal.signupLink.create(payload);
}

export async function disablePaypalIntegration({
  apiClient,
  merchantId,
}: DisablePaypalIntegrationRequestParams): Promise<DisablePaypalIntegrationResponse> {
  const payload = { merchant: { id: merchantId } };
  return apiClient.payPal.deactivate.create(payload);
}

export async function fetchShorePayOnlineOnboardingLink({
  apiClient,
  company,
  taxId,
  merchantId,
}: FetchShorePayOnlineOnboardingLinkRequestParams): Promise<FetchShorePayOnlineOnboardingLinkResponse> {
  const payload = {
    source: company,
    merchant_id: merchantId,
    ...(taxId && { tax_number: taxId }),
  };
  return apiClient.shorepayV1.initiateAccountCreation(payload);
}
export async function updatePaymentMethodsV2({
  apiClient,
  payload,
}: {
  apiClient: any;
  payload: UpdatePaymentMethodsV2Payload;
}) {
  return apiClient.merchantPaymentSettingsV2b.updatePaymentMethods(payload);
}

export async function toggleSubPaymentMethodV2({
  apiClient,
  subPaymentMethodName,
  enabled,
}: ToggleSubPaymentMethodV2RequestParams): Promise<ToggleSubPaymentMethodV2Response> {
  await updatePaymentMethodsV2({
    apiClient,
    payload: {
      payment_methods: [
        {
          name: 'shorepay_online',
          meta: { payment_methods: [{ name: subPaymentMethodName, enabled }] },
        },
      ],
    },
  });
  return { data: { name: subPaymentMethodName, enabled } };
}
